const Test = () => {
  console.log('Hello react');

  return <div>.</div>;
};

export default Test;
